import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { Select, Button, ButtonType } from 'react-magma-dom';

import Input from 'components/MagmaInput';

const numericalParameterFilter = [
  { value: 'GT', label: 'Greater than X' },
  { value: 'GTE', label: 'Greater than or Equal to X' },
  { value: 'LT', label: 'Less than X' },
  { value: 'LTE', label: 'Less than or Equal to X' },
  { value: 'BTW', label: 'Between X and Y' },
  { value: 'EQLNUM', label: 'Equal to X' }
];

const categoricalParameterFilter = [
  { value: 'EQLCAT', label: 'Equal to X' },
  { value: 'NEQL', label: 'Not Equal to X' }
];

const ModalContentComponent = props => {
  const {
    parameter,
    filterType,
    selectError,

    fieldValidator,
    handleSubmit,
    onFilterTypeChange
  } = props;

  const options = parameter.targetType === 'categorical'
    ? categoricalParameterFilter
    : numericalParameterFilter;

  return (
    <div data-testid="modalContentFilterDataSet">
      <div className="main-modal__body">
        <div className="filter-group">
          <div className="filter-column filter-column--large">
            <Select
              inputStyle={{ height: 41 }}
              id="parameter-filter-type-dropdown"
              labelText="Filter Type"
              items={options}
              selectedItem={options.find(({ value }) => value === filterType) || ''}
              onSelectedItemChange={({ selectedItem }) => onFilterTypeChange(selectedItem.value)}
              errorMessage={selectError}
            />
          </div>

          <div className="filter-column filter-column--small">
            <Field
              name="x"
              label="X"
              component={Input}
              placeholderValue="Value..."
              id="x-parameter-filter-value"
              validate={fieldValidator}
            />
          </div>
          {filterType === 'BTW' &&
            <div className="filter-column filter-column--small">
              <Field
                name="y"
                label="Y"
                component={Input}
                placeholderValue="Value..."
                id="y-parameter-filter-value"
                validate={fieldValidator}
              />
            </div>
          }
        </div>

        <div className="main-modal__footer">
          <div className="text-center mb-10">
            <Button
              style={{ fontSize: '14px' }}
              type={ButtonType.button}
              onClick={handleSubmit}
            >
              Add Filter
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

ModalContentComponent.propTypes = {
  // values
  parameter: PropTypes.shape({
    name: PropTypes.string.isRequired,
    targetType: PropTypes.string.isRequired
  }).isRequired,
  selectError: PropTypes.string.isRequired,
  filterType: PropTypes.string,

  fieldValidator: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onFilterTypeChange: PropTypes.func.isRequired
};

export default reduxForm({ form: 'Parameter.Filter.Options' })(
  ModalContentComponent
);
